export default __webpack_public_path__ + "static/media/single-both-border-both.fb5c8a3c.svg";